import { BacksplashModelNumber } from './Enums';

/**
 * The width of each backsplash model in inches.
 * @type {Object<BacksplashModelNumber, string>}
 */
export const modelNumberLookup = {
  [BacksplashModelNumber.LCHD700]: 'LCHD 700',
  [BacksplashModelNumber.LCHD900]: 'LCHD 900',
  [BacksplashModelNumber.LCHD1000]: 'LCHD 1000',
  [BacksplashModelNumber.LCHD1100]: 'LCHD 1100',
  [BacksplashModelNumber.LCHD1400]: 'LCHD 1400',
  [BacksplashModelNumber.LCHD1500]: 'LCHD 1500',
  [BacksplashModelNumber.LCHD1800]: 'LCHD 1800',
  [BacksplashModelNumber.LCHD2200]: 'LCHD 2200',
};

/**
 * The width of each backsplash model in inches.
 * @type {Object<BacksplashModelNumber, string>}
 */
export const widthLookup = {
  [BacksplashModelNumber.LCHD700]: '27 9/16"',
  [BacksplashModelNumber.LCHD900]: '35 7/16"',
  [BacksplashModelNumber.LCHD1000]: '39 3/8"',
  [BacksplashModelNumber.LCHD1100]: '43 1/2"',
  [BacksplashModelNumber.LCHD1400]: '55 5/16"',
  [BacksplashModelNumber.LCHD1500]: '59 1/4"',
  [BacksplashModelNumber.LCHD1800]: '71 1/16"',
  [BacksplashModelNumber.LCHD2200]: '86 13/16"',
};
